import React, { useEffect } from "react";
import SearchCriteria from "../../Utils/SearchCriteria";
// import SearchResults from '../../Utils/SearchResults';
import { Container, Alert } from "reactstrap";
import { connect, useDispatch } from "react-redux";
import errors from "../../Constants/errors.json";
import Mapping from "../../Utils/Mapping";
// import { getUserDetails, errorWhileFetch, setUserList } from '../../../actions/users';
import { Loading } from "../../../loader/Loading";
import { Link } from "react-router-dom";
import DocumentTitle from "react-document-title";
import { enAPI } from "../../../config";
import InfiniteScrollTable from "../../Common/InfiniteScrollCognito";

const ModifySearch = (props) => {
  // const [state, setState] = useState({
  //   modal: false,
  //   property: undefined,
  // });

  const dispatch = useDispatch();

  // const clearError = () => {
  //   dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
  // };
  // const clearUsersList = () => {
  //   dispatch({
  //     type: "USERS_LIST",
  //     data: { usersList: undefined, lastKey: undefined },
  //   });
  //   dispatch({
  //     type: "SET_SEARCH_ATTRIBUTE",
  //     data: { searchAttributes: undefined },
  //   });
  // };
  // const getUserDetails = (username) => dispatch(getUserDetails(username));
  const errorWhileFetch = (err) => dispatch(errorWhileFetch(err));
  const setUserList = (...props) => dispatch(setUserList(...props));

  // const setProperty = (value) => {
  // 	setState({
  // 		...state,
  // 		property: value,
  // 	});
  // 	toggle();
  // };

  // const toggle = () => {
  //   setState({
  //     ...state,
  //     modal: !state.modal,
  //   });
  // };

  useEffect(() => {
    dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
    dispatch({
      type: "USERS_LIST",
      data: { usersList: undefined, lastKey: undefined },
    });
    dispatch({
      type: "SET_SEARCH_ATTRIBUTE",
      data: { searchAttributes: undefined },
    });
    return () => {
      dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
      dispatch({
        type: "USERS_LIST",
        data: { usersList: undefined, lastKey: undefined },
      });
      dispatch({
        type: "SET_SEARCH_ATTRIBUTE",
        data: { searchAttributes: undefined },
      });
    };
  }, [dispatch]);

  const { isLoading, error, usersList, searchAttributes, app } = props;
  const cols = [
    {
      label: "UserName",
      dataKey: "email",
      width: "250",
      customCell: (props) => {
        const { rowData } = props;
        return (
          <Link
            to={`/modify/${rowData.Username}`}
            style={{
              backgroundColor: "none",
              borderColor: "none",
              color: "blue",
            }}
          >
            {rowData.email}
          </Link>
        );
      },
    },
    {
      label: "First Name",
      dataKey: "given_name",
      width: "100",
    },
    {
      label: "Last Name",
      dataKey: "family_name",
      width: "100",
    },
    {
      label: "Company",
      dataKey: "custom:company",
      width: "250",
    },
  ];
  return (
    <DocumentTitle title={"Doorkeeper | Modify User"}>
      <Container style={{ padding: "0% 2%" }}>
        <h5 style={{ marginLeft: "42%" }}>Modify User</h5>
        <SearchCriteria />
        {isLoading && !error && <Loading />}
        {usersList && usersList.length > 0 && searchAttributes && !error && (
          /*<SearchResults
							columns={columns}
							data={this.props.usersList}
							tableHeight={'50vh'}
						/>*/
          <InfiniteScrollTable
            columnData={cols}
            data={usersList}
            gridClassName={"gridClass"}
            rowHeight={45}
            page={"viewSearch"}
            url={`${enAPI}${app}/searchusers`}
            lastKey={props.lastKey}
            authToken={props.authToken}
            searchAttributes={searchAttributes}
            errorWhileFetch={errorWhileFetch}
            setUserList={setUserList}
          />
        )}
        {!error && usersList && usersList.length === 0 && !isLoading && (
          <Alert color="info" style={{ textAlign: "center" }}>
            <h6>No records found.</h6>
          </Alert>
        )}
        {error && (
          <Alert color="danger" style={{ textAlign: "center" }}>
            <h5>
              <Mapping dictionary={errors} word={error.errorPath} />
            </h5>
          </Alert>
        )}
      </Container>
    </DocumentTitle>
  );
};

const mapStateToProps = (state) => {
  return {
    usersList: state.users.usersList,
    isLoading: state.fetch.isLoading,
    error: state.error.error_obj,
    userDetails: state.users.userDetails,
    app: state.pool.userPool,
    authToken: state.auth.token,
    searchAttributes: state.users.searchAttributes,
    lastKey: state.users.lastKey,
  };
};

export default connect(mapStateToProps)(ModifySearch);
